<template>
    <div class="hybrid-filter--container bg-black-50 ">
        <form v-on:submit="submit">
            <h3 class="text-white text-uppercase heading pb-2">Find the right Hybrid</h3>
            <div :class="['item', 'text-center', step == 1 ? '' : 'd-none']">
                <div class="item-header">
                    <span class="count text-white">1</span>
                    <h2 class="text-white">Where are you?</h2>
                </div>
                <div class="row mx-n2 pt-md-4">
                    <div class="col-6 px-2 text-md-right pr-md-5">
                        <div class="map-container-wrapper map-container-wrapper__upper">
                            <a  v-on:click="updateFilter('island', 'Upper North Island')"
                                href="javascript:void(0)"
                                class="map-container">
                            </a>
                            <h3 class="map-container-heading mt-5">Upper North Island</h3>
                        </div>
                    </div>
                    <div class="col-6 px-2 text-md-left pl-md-5">

                        <div class="map-container-wrapper map-container-wrapper__lower">
                            <a  v-on:click="updateFilter('island', 'Lower North Island')"
                                href="javascript:void(0)"
                                class="map-container">
                                <!-- <img class="hybrid-filter--img" src="/img/site/lower-north-island-gd.svg" alt="Lower North Island"> -->
                            </a>
                            <h3 class="map-container-heading mt-5">Lower North Island</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="['item', 'text-center', step == 2 ? '' : 'd-none']">
                <div class="item-header">
                    <span class="count text-white">2</span>
                    <h2 class="text-white">What's it for?</h2>
                </div>
                <div class="row pt-4">
                    <div class="col-6 text-md-right pr-md-5">
                        <div class="map-container-wrapper map-container-wrapper__cow">
                            <a  v-on:click="updateFilter('type', 'Silage')"
                                href="javascript:void(0)"
                                class="map-container map-container__lg">
                                <!-- <img class="hybrid-filter--img" src="/img/site/cow-gd.svg" alt="Silage"> -->
                            </a>
                            <h3 class="map-container-heading mt-5">Silage</h3>
                        </div>
                    </div>
                    <div class="col-6 text-md-left pl-md-5">
                        <div class="map-container-wrapper map-container-wrapper__corn">
                            <a  v-on:click="updateFilter('type', 'Grain')"
                                href="javascript:void(0)"
                                class="map-container">
                                <!-- <img class="hybrid-filter--img" src="/img/site/corn-gd.svg" alt="grain"> -->
                            </a>
                            <h3 class="map-container-heading mt-5">Grain</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="['item', 'text-center', step == 3 ? '' : 'd-none']">
                <div class="item-header">
                    <span class="count text-white">3</span>
                    <h2 v-if="type == 'Grain'" class="text-white">What maturity do you want?</h2>
                    <h2 v-else class="text-white">When do you want to harvest?</h2>
                </div>

                <h4 class="text-white p-0 m-0" v-if="type == 'Grain'">Drag to select CRM <span type="button" class="small text-underline mb-2" data-toggle="modal" data-target="#CRMModal">
  (what is CRM?)
</span></h4>
                <h4 class="text-white p-0 m-0" v-else>Drag to find harvest days</h4>
                <div class="slider-component">
                    <div class="row">
                        <div :class="['col-md-8', 'offset-md-2', type == 'Grain' ? '' : 'd-none']">
                            <input v-model="grainMaturity"
                                id="grain-harvest-days"
                                type="text"
                                data-slider-handle="custom"
                                data-slider-tooltip="hide"
                                data-slider-min="87"
                                data-slider-max="107"
                                data-slider-step="1"
                                data-slider-value="97"/>
                        </div>

                        <div :class="['col-md-8', 'offset-md-2', type != 'Grain' ? '' : 'd-none']">
                            <input v-model="silageMaturity"
                                id="silage-harvest-days"
                                type="text"
                                data-slider-handle="custom"
                                data-slider-tooltip="hide"
                                data-slider-min="124"
                                data-slider-max="160"
                                data-slider-step="1"
                                data-slider-value="142"/>
                        </div>
                    </div>
                    <div class="row pt-2 pt-xl-4">
                        <div class="col-md-8 offset-md-2 mt-auto">

                            <div class="row d-flex justify-content-center">
                                    <!-- <span class="text-white hybrid-filter--days hybrid-filter--days__left">124 Days</span> -->
                                    <span v-if="type == 'Grain'"
                                        class="text-white hybrid-filter--days"
                                        >{{ grainMaturity }} CRM</span>
                                    <span v-else
                                        class="text-white hybrid-filter--days"
                                        >{{ silageMaturity }} Days</span>
                                    <!-- <span class="text-white hybrid-filter--days hybrid-filter--days__right">160 Days</span> -->
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-primary btn-submit" type="submit">Submit</button>
            </div>
            <div class="counter">
                <span v-for="index in [1, 2, 3]"
                    v-on:click="() => step = index"
                    :key="index"
                    :class="['counter--item', index == step ? 'active' : '']"></span>
            </div>
        </form>
        <!-- Modal -->
        <div class="modal fade CRMModal" id="CRMModal" tabindex="-1" role="dialog" aria-labelledby="CRMModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header pb-0 border-0 d-flex align-items-center">
                        <h5 class="modal-title text-center" id="CRMModalLabel">CRMs: What hybrid should I choose?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body copy">

                        <p>Comparative Relative Maturity (CRM) measures the relative rates at which hybrids reach harvest maturity. They don’t represent actual calendar days from planting to harvest. Instead they measure how much sunshine (measured in heat units) the plants need to get to harvest maturity from planting date – the smaller the CRM rating, the lower the heat units it takes to get this hybrid to harvest maturity:</p>
                        <ul>
                            <li>If your planting to harvest window is relatively short or you are planting in a cooler environment, then a short to medium CRM (83 – 102) is the way to go</li>
                            <li>In warmer areas with longer planting windows, a higher CRM (105 -110) is what you’re looking for.</li>
                        </ul>
                        <p>If you have any questions or just want a hand with your planning, feel free to give us a bell. </p>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>
<script>
export default {
    data() {
        return {
            step: 1,
            type: null,
            island: null,
            silageMaturity: 142,
            grainMaturity: 97,
        }
    },

    mounted() {
        this.$nextTick(() => {
            $("#grain-harvest-days").slider();
            $("#grain-harvest-days").on("slide", (slideEvt) => {
                this.grainMaturity = slideEvt.value;
                this.$forceUpdate();
            });

            $("#silage-harvest-days").slider();
            $("#silage-harvest-days").on("slide", (slideEvt) => {
                this.silageMaturity = slideEvt.value;
                this.$forceUpdate();
            });
        })

    },

    computed: {
        formUrl() {
            let params = new URLSearchParams({
                type: this.type || '',
                island: this.island || '',
                maturity_day: this.type == 'Grain' ? this.grainMaturity : this.silageMaturity,
            });

            return `/our-hybrids?${params}`;
        },
    },

    methods: {
        updateFilter(field, value) {
            this.step = this.step + 1;
            this[field] = value;

            if (field == 'type' && value == 'Grain') {
                this.island = 'Upper North Island';
            }

            this.$forceUpdate();
        },

        submit(e) {
            e.preventDefault();
            window.open(this.formUrl, '_self');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/site/js/components/HybridCarouselComponent.vue